/*
 * compat-finder.js — WP 3.2 Kompatibilitäts-Finder (dependency-free Insel).
 *
 * EIN Render-Pfad, zwei Modi (inline auf der Kompatibilitätsseite + Dialog-Body global).
 * Hydratisiert JEDES [data-compat-finder]. 2-Schritt-Wizard (System -> Zentrale -> Verdikt),
 * reaktiv (kein "Weiter"-Button) gemäß State-Modell der Spec (§0):
 *   sys === 'none'                  -> info-Verdikt (kein Hub-Step)
 *   sys && hub gewählt && thread===true  -> grün
 *   sys && hub gewählt && thread===false -> amber
 *   sonst                           -> Empty-State.
 *
 * Daten/Texte kommen aus den vom Section emittierten JSON-Blöcken
 * (#compat-finder-data / #compat-finder-strings) — JS bleibt i18n- und datenrein.
 * Dialog-Öffnen übernimmt overlay.js deklarativ (data-overlay-open="compat-finder").
 */
(function () {
  'use strict';

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Shopifys `| t`-Filter HTML-escaped die Locale-Texte (z. B. „&" -> „&amp;"). Da wir sie
  // im JS als textContent (Klartext) setzen, würden Entities sonst wörtlich erscheinen.
  // Einmaliges Decodieren über ein Detached-Textarea-Element macht daraus wieder echte Zeichen.
  function decodeEntities(str) {
    if (str == null || String(str).indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function el(tag, cls, attrs) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }

  function interpolate(tpl, vars) {
    return String(tpl == null ? '' : tpl).replace(/\{(\w+)\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m;
    });
  }

  // Minimal **bold** -> <strong> (Spec-Body nutzt Markdown-Fett). Restlicher Text escaped.
  function richText(node, str) {
    var parts = String(str == null ? '' : str).split(/\*\*(.+?)\*\*/g);
    parts.forEach(function (chunk, i) {
      if (i % 2 === 1) {
        var s = document.createElement('strong');
        s.textContent = chunk;
        node.appendChild(s);
      } else if (chunk) {
        node.appendChild(document.createTextNode(chunk));
      }
    });
  }

  // ---- Icon-Schnipsel (currentColor). Mappt aufs Theme-Icon-Set (icon.liquid). ----
  var ICONS = {
    check: '<path d="M20 6 9 17l-5-5"/>',
    warn: '<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>',
    bolt: '<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>',
    wifi: '<path d="M5 12.5a10 10 0 0 1 14 0M8 16a5 5 0 0 1 8 0"/><path d="M12 20h.01"/>',
    multimedia: '<path d="M9 18V6l10-2v12"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="16.5" cy="16" r="2.5"/>',
    shield: '<path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/>'
  };
  function svg(name, size) {
    var inner = ICONS[name] || ICONS.multimedia;
    var s = size || 20;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' + inner + '</svg>';
  }

  function init() {
    var data = parseJSON('compat-finder-data');
    var strings = parseJSON('compat-finder-strings');
    if (!data || !strings) return;
    if (!Array.isArray(data.systems) || !data.systems.length) return;
    // Locale-Texte vom `| t`-HTML-Escaping befreien (siehe decodeEntities).
    Object.keys(strings).forEach(function (k) { strings[k] = decodeEntities(strings[k]); });

    var mounts = document.querySelectorAll('[data-compat-finder]');
    Array.prototype.forEach.call(mounts, function (mount) {
      if (mount.__cfReady) return;
      mount.__cfReady = true;
      buildWizard(mount, data, strings);
    });
  }

  function buildWizard(mount, data, strings) {
    // Vorhandenen No-JS-Fallback ersetzen
    mount.innerHTML = '';
    mount.classList.add('hm-cf');

    var systems = data.systems;
    var allHubs = Array.isArray(data.hubs) ? data.hubs : [];
    var targets = data.targets || {};
    var recommended = data.recommendedHub || null;

    var state = { sys: '', hub: null };

    // ---------- Step 1 ----------
    var stepsBar = el('div', 'hm-cf__steps');
    var step1Tag = el('span', 'hm-cf__step hm-cf__step--on');
    step1Tag.innerHTML = '<span class="hm-cf__step-dot">1</span><span class="hm-cf__step-label"></span>';
    step1Tag.querySelector('.hm-cf__step-label').textContent = strings.step1_label;
    var line = el('span', 'hm-cf__steps-line');
    var step2Tag = el('span', 'hm-cf__step');
    step2Tag.innerHTML = '<span class="hm-cf__step-dot">2</span><span class="hm-cf__step-label"></span>';
    step2Tag.querySelector('.hm-cf__step-label').textContent = strings.step2_label;
    stepsBar.appendChild(step1Tag);
    stepsBar.appendChild(line);
    stepsBar.appendChild(step2Tag);

    // Schritt-1-Kopf identisch zu Schritt 2 aufbauen: nummerierter Token „1" + linksbündiger Titel,
    // darunter der Hinweis als eigene Zeile (gleiche Klassen → gleiche Breite/Ausrichtung wie Schritt 2).
    var s1head = el('div', 'hm-cf__s2head');
    var s1tok = el('span', 'hm-cf__s2tok');
    s1tok.textContent = '1';
    var s1titleWrap = el('div');
    var s1title = el('p', 'hm-cf__s2title');
    s1title.textContent = strings.step1_title;
    s1titleWrap.appendChild(s1title);
    s1head.appendChild(s1tok);
    s1head.appendChild(s1titleWrap);
    var s1hint = el('p', 'hm-cf__s2hint');
    s1hint.textContent = strings.step1_hint;

    var sysRow = el('div', 'hm-cf__sys', { role: 'group', 'aria-label': strings.step1_title });
    var sysCards = {};
    systems.forEach(function (sy) {
      var card = el('button', 'hm-cf__syscard', { type: 'button', 'aria-pressed': 'false', 'data-sys': sy.key });
      var badge = el('span', 'hm-cf__sysbadge');
      badge.style.background = sy.bg || 'var(--color-border-light)';
      badge.style.color = sy.fg || 'var(--accent)';
      badge.textContent = sy.mark || (sy.name || '?').charAt(0);
      var label = el('span', 'hm-cf__syslabel');
      label.textContent = sy.name;
      card.appendChild(badge);
      card.appendChild(label);
      card.addEventListener('click', function () { pickSys(sy.key); });
      sysRow.appendChild(card);
      sysCards[sy.key] = card;
    });

    // ---------- Step 2 (Container, befüllt bei Systemwahl) ----------
    var step2 = el('div', 'hm-cf__step2');
    step2.hidden = true;

    // ---------- Result region (aria-live) ----------
    var result = el('div', 'hm-cf__result', { role: 'status', 'aria-live': 'polite' });

    mount.appendChild(stepsBar);
    mount.appendChild(s1head);
    mount.appendChild(s1hint);
    mount.appendChild(sysRow);
    mount.appendChild(step2);
    mount.appendChild(result);

    // ---------- State-Transitions ----------
    function systemByKey(key) {
      for (var i = 0; i < systems.length; i++) { if (systems[i].key === key) return systems[i]; }
      return null;
    }
    function hubsForSys(key) {
      return allHubs.filter(function (h) { return h.sys === key; });
    }

    // Nach einer Auswahl sanft zum nächsten Schritt scrollen: Schritt 2 rückt bei Systemwahl in
    // den Blick, das Ergebnis (Schritt 3) bei Zentralenwahl bzw. sys==='none'. Respektiert
    // reduced-motion. Im Dialog scrollt der Dialog-Body, inline die Seite (Offset = sticky Header).
    function scrollToStep(node) {
      if (!node || node.hidden || typeof node.scrollIntoView !== 'function') return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var inDialog = mount.getAttribute('data-mode') === 'dialog';
      var offset = 16;
      if (!inDialog) {
        var header = document.querySelector('.site-header');
        if (header) {
          var pos = window.getComputedStyle(header).position;
          if (pos === 'sticky' || pos === 'fixed') offset += header.getBoundingClientRect().height;
        }
      }
      node.style.scrollMarginTop = offset + 'px';
      try {
        node.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: inDialog ? 'nearest' : 'start' });
      } catch (e) {
        node.scrollIntoView();
      }
    }

    function pickSys(key) {
      state.sys = key;
      state.hub = null;
      Object.keys(sysCards).forEach(function (k) {
        sysCards[k].setAttribute('aria-pressed', k === key ? 'true' : 'false');
      });
      // Analytics (additiv, WP 5.4): Ökosystem-Auswahl melden — consent-gated im Listener.
      try {
        var picked = systemByKey(key);
        document.dispatchEvent(new CustomEvent('compat:select_ecosystem', {
          detail: { system: picked ? picked.name : '', system_key: key }
        }));
      } catch (e) {}
      render();
      // Nach dem Render steht fest, ob Schritt 2 sichtbar ist → dorthin, sonst zum Ergebnis.
      scrollToStep(step2.hidden ? result : step2);
    }
    function pickHub(hub) {
      state.hub = hub;
      render();
      scrollToStep(result);
    }

    function render() {
      var sys = state.sys ? systemByKey(state.sys) : null;
      var hubStepShown = !!(sys && sys.key !== 'none' && hubsForSys(sys.key).length > 0);

      // Step-Indikator 2
      if (hubStepShown) step2Tag.classList.add('hm-cf__step--on');
      else step2Tag.classList.remove('hm-cf__step--on');

      // Step 2 rendern
      if (hubStepShown) {
        renderStep2(sys);
        step2.hidden = false;
      } else {
        step2.hidden = true;
        step2.innerHTML = '';
      }

      // Verdikt / Empty
      result.innerHTML = '';
      if (sys && sys.key === 'none') {
        result.appendChild(verdictCard('info', sys, null));
        emitCheck('info', sys, null);
      } else if (sys && state.hub) {
        var verdict = state.hub.thread === true ? 'green' : 'amber';
        result.appendChild(verdictCard(verdict, sys, state.hub));
        emitCheck(verdict, sys, state.hub);
      } else {
        var empty = el('div', 'hm-cf__empty');
        empty.textContent = strings.empty_state;
        result.appendChild(empty);
      }
    }

    // Analytics (additiv, WP 5.4): Verdikt melden — consent-gated im Listener.
    function emitCheck(verdict, sys, hub) {
      try {
        document.dispatchEvent(new CustomEvent('compat:check', {
          detail: {
            system: sys ? sys.name : '',
            system_key: sys ? sys.key : '',
            hub: hub ? hub.key : '',
            hub_name: hub ? hub.name : '',
            verdict: verdict
          }
        }));
      } catch (e) {}
    }

    function renderStep2(sys) {
      step2.innerHTML = '';
      var head = el('div', 'hm-cf__s2head');
      var tok = el('span', 'hm-cf__s2tok');
      tok.textContent = '2';
      var titleWrap = el('div');
      var title = el('p', 'hm-cf__s2title');
      title.textContent = interpolate(strings.step2_title, { system: sys.name });
      titleWrap.appendChild(title);
      head.appendChild(tok);
      head.appendChild(titleWrap);
      step2.appendChild(head);

      var hint = el('p', 'hm-cf__s2hint');
      hint.textContent = strings.step2_hint;
      step2.appendChild(hint);

      var grid = el('div', 'hm-cf__hubs', { role: 'group', 'aria-label': title.textContent });
      hubsForSys(sys.key).forEach(function (hub) {
        grid.appendChild(hubCard(hub, sys));
      });
      step2.appendChild(grid);
    }

    function hubCard(hub, sys) {
      var card = el('button', 'hm-cf__hubcard', { type: 'button', 'aria-pressed': 'false' });
      var selected = state.hub && state.hub.key === hub.key;
      if (selected) {
        card.setAttribute('data-sel', hub.thread === true ? 'green' : 'amber');
        card.setAttribute('aria-pressed', 'true');
      }
      var ico = el('span', 'hm-cf__hubico');
      if (hub.img) {
        // Echtes Produktfoto der Zentrale (aus dem Hub-Metaobjekt) — weißer Grund + contain.
        ico.classList.add('hm-cf__hubico--img');
        var hubImg = el('img', 'hm-cf__hubimg', { src: hub.img, alt: '', loading: 'lazy', width: '46', height: '46' });
        ico.appendChild(hubImg);
      } else {
        // Fallback ohne Foto: neutrales Hub-Symbol (NICHT hub.icon — die Marken-Keys wie
        // „apple"/„google" sind keine realen Icons und würden auf die Musiknote zurückfallen).
        if (!selected) ico.style.color = sys.fg || 'var(--accent)';
        ico.innerHTML = svg('shield', 22);
      }

      var body = el('div', 'hm-cf__hubbody');
      var name = el('span', 'hm-cf__hubname');
      name.textContent = hub.name;
      body.appendChild(name);
      if (hub.model) {
        var model = el('span', 'hm-cf__hubmodel');
        model.textContent = hub.model;
        body.appendChild(model);
      }
      var chip = el('span', 'hm-cf__chip ' + (hub.thread === true ? 'hm-cf__chip--ok' : 'hm-cf__chip--no'));
      chip.textContent = hub.thread === true ? strings.chip_thread : strings.chip_nothread;
      body.appendChild(chip);

      var dot = el('span', 'hm-cf__hubdot');
      dot.innerHTML = svg(hub.thread === true ? 'check' : 'warn', 14);

      card.appendChild(ico);
      card.appendChild(body);
      card.appendChild(dot);
      card.addEventListener('click', function () { pickHub(hub); });
      return card;
    }

    function verdictCard(kind, sys, hub) {
      var hubName = hub ? hub.name : '';
      var vars = { hub_name: hubName, system: sys ? sys.name : '' };

      var conf = {
        green: {
          pill: strings.pill_green, icon: 'check',
          title: interpolate(strings.title_green, vars),
          body: strings.body_green,
          t1: [strings.tile_green_1_title, strings.tile_green_1_text, 'bolt'],
          t2: [strings.tile_green_2_title, strings.tile_green_2_text, 'wifi'],
          cta: strings.cta_green, target: targets.green, rec: false
        },
        amber: {
          pill: strings.pill_amber, icon: 'warn',
          title: interpolate(strings.title_amber, vars),
          body: strings.body_amber,
          t1: [strings.tile_amber_1_title, strings.tile_amber_1_text, 'wifi'],
          t2: [strings.tile_amber_2_title, strings.tile_amber_2_text, 'bolt'],
          cta: strings.cta_amber, target: targets.amber, rec: true
        },
        info: {
          pill: strings.pill_info, icon: 'check',
          title: interpolate(strings.title_info, vars),
          body: strings.body_info,
          t1: [strings.tile_info_1_title, strings.tile_info_1_text, 'shield'],
          t2: [strings.tile_info_2_title, strings.tile_info_2_text, 'check'],
          cta: strings.cta_info,
          target: recommended ? recommended.url : targets.green, rec: true
        }
      }[kind];

      var badgeMark = sys ? (sys.mark || (sys.name || '?').charAt(0)) : '?';
      var badgeFg = sys ? (sys.fg || 'var(--accent)') : '#df8911';

      var wrap = el('div', 'hm-cf__verdict', { 'data-verdict': kind });

      // Header
      var head = el('div', 'hm-cf__vhead');
      var badge = el('span', 'hm-cf__vbadge');
      if (hub && hub.img) {
        // Schritt-3-Ergebnis: Foto der gewählten Zentrale oben links (statt System-Textkürzel).
        badge.classList.add('hm-cf__vbadge--img');
        var badgeImg = el('img', 'hm-cf__vbadgeimg', { src: hub.img, alt: '', width: '54', height: '54' });
        badge.appendChild(badgeImg);
      } else {
        badge.style.color = badgeFg;
        badge.textContent = badgeMark;
      }
      var copy = el('div', 'hm-cf__vhead-copy');
      var eyebrow = el('span', 'hm-cf__veyebrow');
      eyebrow.textContent = strings.verdict_eyebrow;
      var vtitle = el('span', 'hm-cf__vtitle');
      vtitle.textContent = conf.title;
      copy.appendChild(eyebrow);
      copy.appendChild(vtitle);
      var pill = el('span', 'hm-cf__vpill');
      pill.innerHTML = svg(conf.icon, 15) + '<span></span>';
      pill.querySelector('span').textContent = conf.pill;
      head.appendChild(badge);
      head.appendChild(copy);
      head.appendChild(pill);
      wrap.appendChild(head);

      // Body
      var vbody = el('div', 'hm-cf__vbody');
      // Mobile-Pill (im Body)
      var bodyPill = el('span', 'hm-cf__vbody-pill');
      bodyPill.innerHTML = svg(conf.icon, 14) + '<span></span>';
      bodyPill.querySelector('span').textContent = conf.pill;
      vbody.appendChild(bodyPill);

      var text = el('p', 'hm-cf__vtext');
      richText(text, interpolate(conf.body, vars));
      vbody.appendChild(text);

      var tiles = el('div', 'hm-cf__vtiles');
      tiles.appendChild(infoTile(conf.t1, vars));
      tiles.appendChild(infoTile(conf.t2, vars));
      vbody.appendChild(tiles);

      // Empfehlung (amber + info): empfohlener Hub als Hinweis-Zeile
      if (conf.rec && recommended) {
        var rec = el('div', 'hm-cf__vrec');
        rec.innerHTML = svg('shield', 18);
        var recText = el('span');
        var priceSuffix = recommended.price ? ' — ' + recommended.price : '';
        recText.textContent = strings.recommended_label + ': ';
        var recLink = el('a', null, { href: recommended.url });
        recLink.textContent = recommended.title + priceSuffix;
        recText.appendChild(recLink);
        rec.appendChild(recText);
        vbody.appendChild(rec);
      }

      // CTA-Reihe
      var ctaRow = el('div', 'hm-cf__vcta');
      if (conf.target) {
        var primary = el('a', 'hm-cf__btn hm-cf__btn--primary', { href: conf.target });
        primary.appendChild(document.createTextNode(conf.cta));
        ctaRow.appendChild(primary);
      }
      if (targets.configurator) {
        var secondary = el('a', 'hm-cf__btn hm-cf__btn--secondary', { href: targets.configurator });
        secondary.textContent = strings.cta_secondary;
        ctaRow.appendChild(secondary);
      }
      vbody.appendChild(ctaRow);

      wrap.appendChild(vbody);
      return wrap;
    }

    function infoTile(spec, vars) {
      vars = vars || {};
      var tile = el('div', 'hm-cf__vtile');
      var th = el('div', 'hm-cf__vtile-head');
      var ti = el('span', 'hm-cf__vtile-ico');
      ti.innerHTML = svg(spec[2] || 'check', 18);
      var tt = el('span', 'hm-cf__vtile-title');
      tt.textContent = interpolate(spec[0], vars);
      th.appendChild(ti);
      th.appendChild(tt);
      var tx = el('p', 'hm-cf__vtile-text');
      tx.textContent = interpolate(spec[1], vars);
      tile.appendChild(th);
      tile.appendChild(tx);
      return tile;
    }

    // initialer Empty-State
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
